import { getUndeadBlocksFilterOptions } from './undeadBlocks';
import { CurrencyOptions } from '../../../../contexts/CurrencyContext';
import { getFantomSurvivorFilterOptions } from './fantomSurvivor';
import { getPlanetIxFilterOptions } from './planetIx';

function mapGame(title: string, currencyOptions: CurrencyOptions) {
  switch (title) {
    case 'undead blocks':
      return getUndeadBlocksFilterOptions(currencyOptions);
    case 'fantom survivor':
      return getFantomSurvivorFilterOptions(currencyOptions);
    case 'planet ix':
      return getPlanetIxFilterOptions(currencyOptions);
  }
  return undefined;
}

export function getGameFilterOptions(
  title: string,
  currencyOptions: CurrencyOptions,
) {
  return mapGame(title.toLowerCase(), currencyOptions);
}
